import { Link } from "react-router-dom";
import { FaCalculator } from 'react-icons/fa6'
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";


export default function MenuRanking() {
    return <>
        <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>Ranking</Breadcrumb.Item>
        </Breadcrumb>
        <nav>
            <Row>
                <Col sm="6" className="mb-2">
                    <Link to="/ranking/clientes">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCalculator></FaCalculator>
                                </Card.Title>
                                <Card.Text>Clientes</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="6" className="mb-2">
                    <Link to="/ranking/marcas">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCalculator></FaCalculator>
                                </Card.Title>
                                <Card.Text>Marcas</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
    </>
}